/*
 * Copyright (C) 2020 Graylog, Inc.
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the Server Side Public License, version 1,
 * as published by MongoDB, Inc.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * Server Side Public License for more details.
 *
 * You should have received a copy of the Server Side Public License
 * along with this program. If not, see
 * <http://www.mongodb.com/licensing/server-side-public-license>.
 */
// Workaround for IE11, see #7670
const createEvent = (type: string) => {
  const options = { bubbles: true, cancelable: true };

  if (typeof Event === 'function') {
    return new Event(type, options);
  }

  const event = document.createEvent('Event');

  event.initEvent(type, options.bubbles, options.cancelable);

  return event;
};

export default createEvent;
